// extracted by mini-css-extract-plugin
export default {"melodyVideo":"zL-z","isFullWidth":"AL-z","landingPageVideo":"BL-z","play":"CL-z","iframeVideo":"DL-z","playHidden":"EL-z","fullwidth":"FL-z"};